module.exports = __webpack_public_path__ + "img/stock1.f2ba0cd4.png";